import React from 'react';
import styled from 'styled-components';
import LanguageSelector from './LanguageSelector';
import { ScWrapper } from './styles';

const now = new Date();
const currentYear = now.getFullYear();

const ScContainer = styled.div`
  margin-top: 1rem;
  flex: 0 0 auto;

  @media print {
    display: none !important;
  }
`;
const ScLanguageSelector = styled(LanguageSelector)`
  margin-left: 1rem;
`;
const ScContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  border-top: 1px solid #dfdfdf;
  padding: 1rem 5px;
`;

const Footer = () => (
  <ScContainer>
    <ScWrapper>
      <ScContent>
        © {currentYear} XPower N.V. <ScLanguageSelector />
      </ScContent>
    </ScWrapper>
  </ScContainer>
);

export default Footer;
